import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import { mergeRefs, useObjectRef, mergeProps, filterDOMProps } from '@react-aria/utils';
import React__default, { forwardRef, useContext, useMemo } from 'react';
import { DismissButton } from 'react-aria';
import { InternalModalContext } from './context.esm.js';
import ModalOverlay from './modal-overlay.esm.js';
import { OverlayTriggerStateContext } from '../../../dialog/primitives/aria/context.esm.js';
import { useEnterAnimation, useRenderProps } from '../../../utils/index.esm.js';

var _excluded = ["maxHeight", "maxWidth", "marginTop"],
  _excluded2 = ["className"],
  _excluded3 = ["isDismissable", "isKeyboardDismissDisabled", "isOpen", "defaultOpen", "onOpenChange", "children", "isEntering", "isExiting", "UNSTABLE_portalContainer", "shouldCloseOnInteractOutside"];
function ModalContent(_ref) {
  var maxHeight = _ref.maxHeight,
    maxWidth = _ref.maxWidth,
    marginTop = _ref.marginTop,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 =
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    useContext(InternalModalContext),
    modalProps = _ref2.modalProps,
    modalRef = _ref2.modalRef,
    isExiting = _ref2.isExiting,
    isDismissable = _ref2.isDismissable;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var state = useContext(OverlayTriggerStateContext);
  var mergedRefs = useMemo(function () {
    return mergeRefs(props.modalRef, modalRef);
  }, [props.modalRef, modalRef]);
  var ref = useObjectRef(mergedRefs);
  var entering = useEnterAnimation(ref);
  var _useRenderProps = useRenderProps(_objectSpread2(_objectSpread2({}, props), {}, {
      defaultClassName: 'react-aria-Modal',
      values: {
        isEntering: entering,
        isExiting: isExiting,
        state: state
      }
    })),
    className = _useRenderProps.className,
    renderProps = _objectWithoutProperties(_useRenderProps, _excluded2);
  var style = useMemo(function () {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, maxHeight ? {
      '--max-modal-height': maxHeight
    } : {}), maxWidth ? {
      '--max-modal-width': maxWidth
    } : {}), marginTop ? {
      '--modal-margin-top': marginTop
    } : {});
  }, [maxHeight, maxWidth, marginTop]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cn(className, {
      'max-h-[--max-modal-height]': !!maxHeight,
      'max-w-[--max-modal-width]': !!maxWidth,
      'mt-[--modal-margin-top]': !!marginTop
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, mergeProps(filterDOMProps(props), modalProps), renderProps, {
    ref: ref,
    "data-entering": entering || undefined,
    "data-exiting": isExiting || undefined,
    style: style
  }), isDismissable ? /*#__PURE__*/React__default.createElement(DismissButton, {
    onDismiss: state.close
  }) : null, renderProps.children);
}
function Modal(props, ref) {
  var ctx = useContext(InternalModalContext);
  if (ctx) {
    return /*#__PURE__*/React__default.createElement(ModalContent, _extends({}, props, {
      modalRef: ref
    }), props.children);
  }
  var isDismissable = props.isDismissable,
    isKeyboardDismissDisabled = props.isKeyboardDismissDisabled,
    isOpen = props.isOpen,
    defaultOpen = props.defaultOpen,
    onOpenChange = props.onOpenChange,
    children = props.children,
    isEntering = props.isEntering,
    isExiting = props.isExiting,
    UNSTABLE_portalContainer = props.UNSTABLE_portalContainer,
    shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside,
    otherProps = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React__default.createElement(ModalOverlay, {
    isDismissable: isDismissable,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    isEntering: isEntering,
    isExiting: isExiting,
    UNSTABLE_portalContainer: UNSTABLE_portalContainer,
    shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
  }, /*#__PURE__*/React__default.createElement(ModalContent, _extends({}, otherProps, {
    modalRef: ref
  }), children));
}

/**
 * A modal is an overlay element which blocks interaction with elements outside it.
 */
var _Modal = /*#__PURE__*/forwardRef(Modal);
var AriaModal = _Modal;

export { AriaModal as default };
//# sourceMappingURL=modal.esm.js.map
